import {
	Component, Input, Output, EventEmitter, ViewEncapsulation,
	ElementRef, Renderer2, AfterContentInit, HostListener,
	ViewChild
} from '@angular/core';

@Component({
	selector: '[jui-btn]',
	template: `
        <span #rippleCover class="btn-ripple-cover"
            *ngIf="_btnEffect==='ripple'"></span>
        <i class="iconfont icon-jui-loading icon-doTurn"
            *ngIf="_btnLoading"></i>
        <ng-content></ng-content>
    `,
	styles: [`
   @font-face {
     font-family: 'iconfont';
     /* project id 290315 */
     src: url("//at.alicdn.com/t/font_290315_x4r2fph1yvutbj4i.eot");
     src: url("//at.alicdn.com/t/font_290315_x4r2fph1yvutbj4i.eot?#iefix") format("embedded-opentype"), url("//at.alicdn.com/t/font_290315_x4r2fph1yvutbj4i.woff") format("woff"), url("//at.alicdn.com/t/font_290315_x4r2fph1yvutbj4i.ttf") format("truetype"), url("//at.alicdn.com/t/font_290315_x4r2fph1yvutbj4i.svg#iconfont") format("svg"); }

   .iconfont {
     display: inline-block;
     vertical-align: baseline;
     font-family: "iconfont" !important;
     font-style: normal;
     -webkit-font-smoothing: antialiased;
     -moz-osx-font-smoothing: grayscale; }

   .icon-jui-alert:before {
     content: "\\e600"; }

   .icon-jui-search:before {
     content: "\\e630"; }

   .icon-jui-paper3:before {
     content: "\\e652"; }

   .icon-jui-setting:before {
     content: "\\e602"; }

   .icon-jui-left2:before {
     content: "\\e697"; }

   .icon-jui-wrong:before {
     content: "\\e69a"; }

   .icon-jui-up2:before {
     content: "\\e6a5"; }

   .icon-jui-down2:before {
     content: "\\e6a6"; }

   .icon-jui-right2:before {
     content: "\\e6a7"; }

   .icon-jui-correct2:before {
     content: "\\e627"; }

   .icon-jui-qq:before {
     content: "\\e63a"; }

   .icon-jui-email:before {
     content: "\\e62a"; }

   .icon-jui-edit:before {
     content: "\\e686"; }

   .icon-jui-download2:before {
     content: "\\e714"; }

   .icon-jui-speaker:before {
     content: "\\e85c"; }

   .icon-jui-add:before {
     content: "\\e609"; }

   .icon-jui-msg:before {
     content: "\\e613"; }

   .icon-jui-minus:before {
     content: "\\e601"; }

   .icon-jui-up:before {
     content: "\\e658"; }

   .icon-jui-letter-open:before {
     content: "\\e61d"; }

   .icon-jui-down:before {
     content: "\\ed22"; }

   .icon-jui-info:before {
     content: "\\e685"; }

   .icon-jui-cross2:before {
     content: "\\e6b4"; }

   .icon-jui-paper2:before {
     content: "\\e71e"; }

   .icon-jui-loading:before {
     content: "\\eee3"; }

   .icon-jui-road-sign:before {
     content: "\\e604"; }

   .icon-jui-left:before {
     content: "\\e66a"; }

   .icon-jui-letter:before {
     content: "\\e605"; }

   .icon-jui-right:before {
     content: "\\e64d"; }

   .icon-jui-back-top:before {
     content: "\\e628"; }

   .icon-jui-dropdown:before {
     content: "\\e75a"; }

   .icon-jui-down3:before {
     content: "\\e629"; }

   .icon-jui-alarm:before {
     content: "\\e6c2"; }

   .icon-jui-paper:before {
     content: "\\e612"; }

   .icon-jui-cross:before {
     content: "\\e6b0"; }

   .icon-jui-correct:before {
     content: "\\e6b3"; }

   .icon-jui-up3:before {
     content: "\\eee4"; }

   .icon-jui-username:before {
     content: "\\e670"; }

   .icon-jui-password:before {
     content: "\\e615"; }

   .icon-jui-slideLeft:before {
     content: "\\e603"; }

   .icon-jui-slideRight:before {
     content: "\\e641"; }

   /* icon Animate */
   .icon-doTurn {
     -webkit-animation: doTurn 1s infinite linear;
     animation: doTurn 1s infinite linear; }

   @-webkit-keyframes doTurn {
     0% {
       -webkit-transform-origin: 50% 50%;
       -webkit-transform: rotate(0deg); }
     to {
       -webkit-transform-origin: 50% 50%;
       -webkit-transform: rotate(1turn); } }

   @keyframes doTurn {
     0% {
       transform-origin: 50% 50%;
       transform: rotate(0deg); }
     to {
       transform-origin: 50% 50%;
       transform: rotate(1turn); } }
   @charset "UTF-8";
   /* 默认按钮 */
   .jui-btn {
     display: inline-block;
     margin-bottom: 0;
     font-weight: 500;
     text-align: center;
     cursor: pointer;
     background-image: none;
     border: 1px solid #d9d9d9;
     white-space: nowrap;
     line-height: 1.5;
     padding: 0 15px;
     font-size: 12px;
     border-radius: 4px;
     height: 28px;
     -webkit-user-select: none;
     -moz-user-select: none;
     -ms-user-select: none;
     user-select: none;
     -webkit-transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
     transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
     position: relative;
     color: rgba(0, 0, 0, 0.65);
     background-color: #fff;
     /* 基本按钮 */
     /* 虚线按钮 */
     /* 危险按钮 */
     /* loading */
     /* 圆圈 */
     /* 禁用按钮 */
     /* 按钮特效-扩散 */
     /* 按钮特效-水波纹 */
     /* 过滤水波纹定位事件 */ }
     .jui-btn:before {
       position: absolute;
       top: -1px;
       left: -1px;
       bottom: -1px;
       right: -1px;
       background: #fff;
       opacity: .35;
       content: "";
       border-radius: inherit;
       z-index: 1;
       -webkit-transition: opacity .2s;
       transition: opacity .2s;
       pointer-events: none;
       display: none; }
     .jui-btn:focus, .jui-btn:hover {
       color: #108ee9;
       background-color: #fff;
       border-color: #108ee9; }
     .jui-btn.active, .jui-btn:active {
       color: #0e77ca;
       background-color: #fff;
       border-color: #0e77ca; }
     .jui-btn.jui-btn-lg {
       padding: 0 15px;
       font-size: 14px;
       border-radius: 4px;
       height: 32px; }
     .jui-btn.jui-btn-sm {
       padding: 0 7px;
       font-size: 12px;
       border-radius: 4px;
       height: 22px; }
     .jui-btn.jui-btn-primary {
       color: #fff;
       background-color: #108ee9;
       border-color: #108ee9; }
       .jui-btn.jui-btn-primary:focus, .jui-btn.jui-btn-primary:hover {
         color: #fff;
         background-color: #49a9ee;
         border-color: #49a9ee; }
       .jui-btn.jui-btn-primary.active, .jui-btn.jui-btn-primary:active {
         color: #fff;
         background-color: #0e77ca;
         border-color: #0e77ca; }
     .jui-btn.jui-btn-dashed {
       color: rgba(0, 0, 0, 0.65);
       background-color: #fff;
       border-color: #d9d9d9;
       border-style: dashed; }
       .jui-btn.jui-btn-dashed:focus, .jui-btn.jui-btn-dashed:hover {
         color: #108ee9;
         background-color: #fff;
         border-color: #108ee9; }
       .jui-btn.jui-btn-dashed.active, .jui-btn.jui-btn-dashed:active {
         color: #0e77ca;
         background-color: #fff;
         border-color: #0e77ca; }
     .jui-btn.jui-btn-danger {
       color: #f04134;
       background-color: #f7f7f7;
       border-color: #d9d9d9; }
       .jui-btn.jui-btn-danger:focus, .jui-btn.jui-btn-danger:hover {
         color: #fff;
         background-color: #f04134;
         border-color: #f04134; }
       .jui-btn.jui-btn-danger.active, .jui-btn.jui-btn-danger:active {
         color: #fff;
         background-color: #d73435;
         border-color: #d73435; }
     .jui-btn.jui-btn.jui-btn-loading {
       position: relative; }
       .jui-btn.jui-btn.jui-btn-loading:before {
         display: block; }
       .jui-btn.jui-btn.jui-btn-loading .icon-loading {
         display: inline-block;
         -webkit-animation: loadingCircle 1s infinite linear;
         animation: loadingCircle 1s infinite linear; }
     .jui-btn.jui-btn-circle {
       width: 28px;
       padding: 0;
       font-size: 14px;
       border-radius: 50%;
       height: 28px; }
       .jui-btn.jui-btn-circle.jui-btn-lg {
         width: 32px;
         padding: 0;
         font-size: 16px;
         border-radius: 50%;
         height: 32px; }
       .jui-btn.jui-btn-circle.jui-btn-sm {
         width: 22px;
         padding: 0;
         font-size: 12px;
         border-radius: 50%;
         height: 22px; }
     .jui-btn.disabled, .jui-btn[disabled] {
       color: rgba(0, 0, 0, 0.25);
       background-color: #f7f7f7;
       border-color: #d9d9d9;
       cursor: not-allowed; }
       .jui-btn.disabled:focus, .jui-btn.disabled:hover, .jui-btn.disabled.active, .jui-btn.disabled:active, .jui-btn[disabled]:focus, .jui-btn[disabled]:hover, .jui-btn[disabled].active, .jui-btn[disabled]:active {
         color: rgba(0, 0, 0, 0.25);
         background-color: #f7f7f7;
         border-color: #d9d9d9; }
     .jui-btn.jui-btn-spread:before {
       content: "";
       position: absolute;
       top: -1px;
       left: -1px;
       bottom: -1px;
       right: -1px;
       border-radius: inherit;
       border: 0 solid #108ee9;
       opacity: .4;
       -webkit-animation: effectSpread .4s;
       animation: effectSpread .4s;
       display: block; }
     .jui-btn.jui-btn-spread.jui-btn-danger:before {
       border-color: #f04134; }
     .jui-btn.jui-btn-ripple {
       overflow: hidden;
       position: relative; }
       .jui-btn.jui-btn-ripple span.btn-ripple-cover {
         pointer-events: none;
         z-index: 1;
         position: absolute;
         top: 0;
         left: 0;
         height: 0;
         width: 0;
         border-radius: 50%;
         background: rgba(255, 255, 255, 0.8);
         -webkit-transform: scale(0);
         transform: scale(0);
         opacity: 1;
         -webkit-animation: effectRipple .4s linear;
         animation: effectRipple .4s linear; }
     .jui-btn i {
       pointer-events: none; }

   /* 动画 */
   @-webkit-keyframes effectSpread {
     to {
       opacity: 0;
       top: -6px;
       left: -6px;
       bottom: -6px;
       right: -6px;
       border-width: 6px; } }

   @keyframes effectSpread {
     to {
       opacity: 0;
       top: -6px;
       left: -6px;
       bottom: -6px;
       right: -6px;
       border-width: 6px; } }

   @-webkit-keyframes effectRipple {
     100% {
       -webkit-transform: scale(2);
       transform: scale(2);
       opacity: 0; } }

   @keyframes effectRipple {
     100% {
       -webkit-transform: scale(2);
       transform: scale(2);
       opacity: 0; } }

   @-webkit-keyframes loadingCircle {
     from {
       -webkit-transform-origin: 50% 50%;
       transform-origin: 50% 50%;
       -webkit-transform: rotate(0deg);
       transform: rotate(0deg); }
     to {
       -webkit-transform-origin: 50% 50%;
       transform-origin: 50% 50%;
       -webkit-transform: rotate(1turn);
       transform: rotate(1turn); } }

   @keyframes loadingCircle {
     from {
       -webkit-transform-origin: 50% 50%;
       transform-origin: 50% 50%;
       -webkit-transform: rotate(0deg);
       transform: rotate(0deg); }
     to {
       -webkit-transform-origin: 50% 50%;
       transform-origin: 50% 50%;
       -webkit-transform: rotate(1turn);
       transform: rotate(1turn); } }
	`],
	encapsulation: ViewEncapsulation.None
})
export class ButtonComponent implements AfterContentInit {
	_btnType = '';
	_btnShape = '';
	_btnSize = '';
	_btnLoading = false;
	_innerIElement: HTMLElement;
	_btnEffect: string;

	prefixCls = 'jui-btn-';
	hostEl: HTMLElement;
	hostCls: string[] = [];
	isClicked = false;

	// 判断按钮内是否有图标
	get innerIElement(): HTMLElement {
		return this.hostEl.querySelector('i');
	}

	@Input()
	get btnType(): string {
		return this._btnType;
	}
	set btnType(value: string) {
		if (!!value && (value === 'primary' || value === 'dashed'
			|| value === 'danger')) {
			this._btnType = value;
		}
		this.setHostCls();
	}
	@Input()
	get btnSize(): string {
		return this._btnSize;
	}
	set btnSize(value: string) {
		if (!!value) {
			if (value === 'small') {
				this._btnSize = 'sm';
			} else if (value === 'large') {
				this._btnSize = 'lg';
			}
		}
		this.setHostCls();
	}
	@Input()
	get btnShape(): string {
		return this._btnShape;
	}
	set btnShape(value: string) {
		if (!!value && (value === 'circle')) {
			this._btnShape = value;
		}
		this.setHostCls();
	}
	@Input()
	get btnLoading(): boolean {
		return this._btnLoading;
	}
	set btnLoading(value: boolean) {
		if (value === true) {
			this._btnLoading = value;
		} else {
			this._btnLoading = false;
		}
		this.setHostCls();
		this.setIconDisplay();
	}
	@Input()
	get btnEffect(): string {
		return this._btnEffect;
	}
	set btnEffect(value: string) {
		// 目前只支持扩散和水波纹两种特效，默认不开启特效
		if (!!value && (value === 'spread' || value === 'ripple')) {
			this._btnEffect = value;
		}
	}

	@ViewChild('rippleCover') rippleCoverEl: ElementRef;

	constructor(
		private elementRef: ElementRef,
		private renderer2: Renderer2
	) {
		this.hostEl = this.elementRef.nativeElement;
		this.renderer2.addClass(this.hostEl, 'jui-btn');
	}

	ngAfterContentInit() {
		// 将此图标缓存起来
		this._innerIElement = this.innerIElement;
		if (this._innerIElement &&
			this.hostEl.children.length === 1 &&
			(this._innerIElement.isEqualNode(this.hostEl.children[0]))) {
			this.setIconDisplay();
		}
	}

	// toggle animation
	@HostListener('click', ['$event']) onClick(event: MouseEvent) {
		if (!this._btnEffect) {
			return;
		}
		// 水波纹特效
		if (this._btnEffect === 'ripple') {
			let size = Math.max(this.hostEl.offsetWidth, this.hostEl.offsetHeight);
			let eventTop = event.offsetY || (event.clientY - this.hostEl.getBoundingClientRect().top);
			let eventLeft = event.offsetX || (event.clientX - this.hostEl.getBoundingClientRect().left);
			let styleMap = {
				top: eventTop - size / 2,
				left: eventLeft - size / 2,
				width: size,
				height: size
			};
			Object.keys(styleMap).forEach((key) => {
				this.renderer2.setStyle(this.rippleCoverEl.nativeElement, key, styleMap[key] + 'px');
			});
		}

		this.isClicked = true;
		this.setHostCls();
		setTimeout(() => {
			this.isClicked = false;
			this.setHostCls();
		}, 300);
	}

	private setHostCls() {
		this.hostCls.forEach((className) => {
			this.renderer2.removeClass(this.hostEl, className);
		});
		this.hostCls = [
			this._btnType && this.prefixCls + this._btnType,
			this._btnShape && this.prefixCls + this._btnShape,
			this._btnSize && this.prefixCls + this._btnSize,
			this._btnLoading && this.prefixCls + 'loading',
			this.isClicked && this.prefixCls + this._btnEffect
		].filter((item) => {
			return !!item;
		});
		// 无法直接添加样式字符串，因为此方法是通过 el.classList.add(name) 方式添加的
		this.hostCls.forEach((className) => {
			this.renderer2.addClass(this.hostEl, className);
		});
	}

	private setIconDisplay() {
		if (this._innerIElement) {
			this.renderer2.setStyle(this._innerIElement, 'display', this._btnLoading ? 'none' : 'inline-block');
		}
	}
}
